import React from 'react';
import type { MotionProps } from 'framer-motion';
import Container, {
  type ContainerProperties,
} from '@/components/ui/layout/container';
import Section from '@/components/ui/layout/section';
import { cn } from '@/lib/utils';

interface SectionBaseProperties extends MotionProps {
  id?: string;
  containerProps?: ContainerProperties;
  className?: string;
  background?: string;
}

const SectionBase = React.forwardRef<HTMLSelectElement, SectionBaseProperties>(
  (
    { id, containerProps = {}, className = '', background, children, ...props },
    ref,
  ) => {
    const section = (
      <Section
        id={id}
        ref={ref}
        className={cn('flex justify-center items-center', className)}
        {...props}
      >
        <Container maxWidth="max-w-5xl" {...containerProps}>
          {children}
        </Container>
      </Section>
    );

    if (background) {
      return <div className={cn('w-full', background)}>{section}</div>;
    }

    return section;
  },
);

export default SectionBase;
